const dashboardButtonsConfig = [
  {
    title: 'Manage devices',
    id: 'devices',
    values: [
      {
        name: 'Total',
        propertyName: 'deviceCount',
      },
      {
        name: 'Active',
        propertyName: 'activeDeviceCount',
      },
    ],
    href: '/devices',
  },
  {
    title: 'Manage customer accounts and organizations',
    id: 'users',
    values: [
      {
        name: 'Total accounts',
        propertyName: 'accountCount',
      },
      {
        name: 'Active accounts',
        propertyName: 'activeAccountCount',
      },
      {
        name: 'Total users',
        propertyName: 'userCount',
      },
      {
        name: 'Active users',
        propertyName: 'activeUserCount',
      },
    ],
    href: '/users',
  },
  {
    title: 'Firmware library',
    id: 'firmware-versions',
    values: [
      {
        name: "Device's types",
        propertyName: 'deviceTypeCount',
      },
    ],
    href: '/firmwares',
  },
  {
    title: 'Manage fleet firmware changes',
    id: 'devices-firmware',
    values: [
      {
        name: 'Scheduled firmware updates',
        propertyName: 'scheduleDeviceCount',
      },
    ],
    href: '/firmware-update/schedule',
  },
  {
    title: 'System configuration page',
    id: 'system-configuration',
    values: [],
    href: '',
  },
  {
    title: 'System health monitoring',
    id: 'system-health-monitoring',
    values: [
      {
        name: 'Current status',
        propertyName: 'status',
      },
      {
        name: 'Number of instances',
        propertyName: 'numberOfInstances',
      },
    ],
    href: '',
  },
  {
    title: 'Organizations',
    id: 'organizations',
    values: [],
    href: '/organizations',
  },
  {
    title: 'Feature Toggling',
    id: 'feature-toggling',
    values: [],
    href: '/feature/toggling',
  },
  {
    title: 'Device Emulator',
    id: 'device-emulator',
    values: [],
    href: '/device/sendCommand',
  },
  {
    title: 'Events Emulator',
    id: 'events-emulator',
    values: [],
    href: '/device/sendMessage',
  },
]

const noInformation = 'No Information'

const localhost = 'http://localhost:8080'

export { dashboardButtonsConfig, noInformation, localhost }
